module.exports = __webpack_public_path__ + "img/s00135.f504ff64.png";